import type { GameState } from "../game/GameState";

export interface PlayerDamageResult {
  readonly healthDamage: number;
  readonly armorDamage: number;
  readonly killed: boolean;
}

export class PlayerHealth {
  public constructor(private readonly state: GameState) {}

  public damage(amount: number): PlayerDamageResult {
    if (this.state.phase === "dead" || this.state.phase === "complete" || amount <= 0) {
      return { healthDamage: 0, armorDamage: 0, killed: false };
    }
    const armorDamage = Math.min(this.state.armor, Math.floor(amount * 0.5));
    const healthDamage = Math.min(this.state.health, amount - armorDamage);
    this.state.armor -= armorDamage;
    this.state.health -= healthDamage;
    const killed = this.state.health <= 0;
    if (killed) {
      this.state.health = 0;
      this.state.phase = "dead";
    }
    return { healthDamage, armorDamage, killed };
  }
}
